// Single source of truth for the "is this periodicity intraday?" rule.
// Extracted from 5 hand-written copies of /^(\d+)(min|h)$/ (dedup audit
// 2026-07-17, item 5c). PriceChangeIndicator.leftPosition depends on
// BarCountdownTimer.shouldShow agreeing on this rule — keeping the regex in
// one place is what keeps them in sync.

/**
 * Parse an intraday periodicity string ("15min", "2h").
 * @param {string} periodicity
 * @returns {{ value: number, unit: "min"|"h" } | null} null for non-intraday
 *   periodicities ("1D", "1W", ...) or non-string input.
 */
export function parseIntradayPeriodicity(periodicity) {
  const m =
    typeof periodicity === "string"
      ? periodicity.match(/^(\d+)(min|h)$/)
      : null;
  if (!m) return null;
  return { value: parseInt(m[1], 10), unit: m[2] };
}

/**
 * @param {string} periodicity
 * @returns {boolean} true for minute/hour periodicities only
 */
export function isIntradayPeriodicity(periodicity) {
  return parseIntradayPeriodicity(periodicity) !== null;
}
